"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var i0 = require("./reset-password-holder.component.scss.shim.ngstyle");
var i1 = require("@angular/core");
var i2 = require("./reset-password-holder.component");
var i3 = require("@angular/material/dialog");
var styles_ResetPasswordHolderComponent = [i0.styles];
var RenderType_ResetPasswordHolderComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_ResetPasswordHolderComponent, data: {} });
exports.RenderType_ResetPasswordHolderComponent = RenderType_ResetPasswordHolderComponent;
function View_ResetPasswordHolderComponent_0(_l) { return i1.ɵvid(0, [], null, null); }
exports.View_ResetPasswordHolderComponent_0 = View_ResetPasswordHolderComponent_0;
function View_ResetPasswordHolderComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-reset-password-holder", [], null, null, null, View_ResetPasswordHolderComponent_0, RenderType_ResetPasswordHolderComponent)), i1.ɵdid(1, 4308992, null, 0, i2.ResetPasswordHolderComponent, [i3.MatDialog], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
exports.View_ResetPasswordHolderComponent_Host_0 = View_ResetPasswordHolderComponent_Host_0;
var ResetPasswordHolderComponentNgFactory = i1.ɵccf("app-reset-password-holder", i2.ResetPasswordHolderComponent, View_ResetPasswordHolderComponent_Host_0, {}, {}, []);
exports.ResetPasswordHolderComponentNgFactory = ResetPasswordHolderComponentNgFactory;
